import { render, staticRenderFns } from "./RiskWarning.vue?vue&type=template&id=256ab8c6&scoped=true&"
import script from "./RiskWarning.vue?vue&type=script&lang=js&"
export * from "./RiskWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ab8c6",
  null
  
)

export default component.exports